import { CookieBanner } from "@/components/cookies/CookieBanner";
import { CookiePreferencesModal } from "@/components/cookies/CookiePreferencesModal";
import { useCookieConsentManager } from "@/hooks/cookies";

export function CookieConsentManager() {
  const {
    consent,
    isPreferencesOpen,
    currentPreferences,
    setIsPreferencesOpen,
    handleAcceptAll,
    handleRejectAll,
    handleSaveCustom,
  } = useCookieConsentManager();

  if (consent) return null;

  return (
    <>
      <CookieBanner onAcceptAll={handleAcceptAll} onRejectAll={handleRejectAll} onConfigure={() => setIsPreferencesOpen(true)} />
      <CookiePreferencesModal
        open={isPreferencesOpen}
        initialPreferences={currentPreferences}
        onOpenChange={setIsPreferencesOpen}
        onSaveCustom={handleSaveCustom}
        onAcceptAll={handleAcceptAll}
        onRejectAll={handleRejectAll}
      />
    </>
  );
}
